module.exports = __webpack_public_path__ + "img/price.23ae9881.svg";